export default {
      id: "insertComment-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#insertComment-usage",
      toString: function () {
        return this.url;
      }
    }